"use client";

import { SearchInput } from "@/features/geo/ui/SearchInput";
import { StepHeading } from "@/features/quote/ui/StepHeading";
import { StepNav } from "@/features/quote/ui/StepNav";
import { useWizard } from "@/features/quote/ui/wizard-context";

export function AddressStep() {
  const {
    state,
    goToStep,
    step,
    stepReady,
    isBusiness,
    handleAddressSelect,
    handleSkipAddress,
    handleResetAddress,
    bbrLoading,
    bbrError,
  } = useWizard();

  return (
    <section>
      <StepHeading
        title={isBusiness ? "Hvor ligger lokalerne?" : "Hvor bor du?"}
        body="Vi henter automatisk boligens størrelse og type fra BBR - så du slipper for at udfylde det selv. Du kan rette det bagefter hvis det er forkert."
        maxW="max-w-[28ch]"
        bodyMaxW="max-w-[52ch]"
      />

      {!state.address && !state.addressSkipped && (
        <div className="max-w-115">
          <SearchInput
            onSelect={handleAddressSelect}
            placeholder="Indtast adresse - fx Vesterbrogade 50"
          />
          <div className="mt-3 flex items-center justify-between gap-4">
            <p className="text-[13px] text-ink-subtle">Mindst 3 tegn. Vi viser op til 8 forslag.</p>
            <button
              type="button"
              onClick={handleSkipAddress}
              className="shrink-0 text-[13px] text-link underline underline-offset-2 hover:text-ink"
            >
              Min adresse er ikke i listen
            </button>
          </div>
        </div>
      )}

      {state.address && (
        <div className="max-w-130 rounded border border-border bg-paper p-4">
          {bbrLoading ? (
            <div className="flex items-center gap-3 text-[14px] text-ink-muted">
              <div className="h-4 w-4 animate-spin rounded-full border-2 border-border border-t-theme-accent" />
              Henter boligoplysninger fra BBR…
            </div>
          ) : (
            <>
              <p className="text-[15px] font-medium text-ink">{state.streetAddress}</p>
              {bbrError ? (
                <p className="mt-2 text-[13px] text-ink-muted">{bbrError}</p>
              ) : (
                <p className="mt-2 text-[13px] text-ink-muted">
                  {state.bbrPrefilled.sqm ||
                  state.bbrPrefilled.propertyType ||
                  state.bbrPrefilled.business
                    ? "Vi har udfyldt et par felter for dig - du kan rette dem på de næste trin."
                    : "Vi fandt adressen, men ingen yderligere detaljer i BBR. Udfyld manuelt på de næste trin."}
                </p>
              )}
              <button
                type="button"
                onClick={handleResetAddress}
                className="mt-3 text-[13px] text-link underline underline-offset-2 hover:text-ink"
              >
                Skift adresse
              </button>
            </>
          )}
        </div>
      )}

      {state.addressSkipped && (
        <div className="max-w-130 rounded border border-border bg-paper p-4">
          <p className="text-[14px] text-ink">
            Du har valgt at springe adresse-opslaget over. Du udfylder selv de næste felter.
          </p>
          <button
            type="button"
            onClick={handleResetAddress}
            className="mt-3 text-[13px] text-link underline underline-offset-2 hover:text-ink"
          >
            Søg adresse alligevel
          </button>
        </div>
      )}

      <StepNav
        onBack={() => goToStep(step - 1)}
        onNext={() => goToStep(step + 1)}
        nextEnabled={stepReady("address") && !bbrLoading}
        nextLabel="Næste →"
      />
    </section>
  );
}
